import { CheckCircle2 } from 'lucide-react';

/**
 * Where HitPay lands a payment started from the app.
 *
 * That payment ran in the phone's browser, not the app, and nobody is signed in
 * there — so this page is public and claims nothing about the order. The
 * credits arrive by webhook; the app's balance is live and shows them.
 */
export default function Paid() {
  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <div className="max-w-sm text-center">
        <CheckCircle2 size={40} className="mx-auto mb-3 text-emerald-400" />
        <h1 className="mb-2 text-xl font-semibold">Payment received</h1>
        <p className="text-sm text-ink-400">
          Close this page and go back to the BlisxBench app. Your credits appear there on their own,
          usually within a few seconds. A receipt is on its way to your email.
        </p>
      </div>
    </div>
  );
}
